import { Box, Flex } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import React from "react";

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
`;

export const TypingIndicator: React.FC<{ size?: number; color?: string }> = ({
  size = 8,
  color = "gray.500",
}) => {
  return (
    <Flex align="center" justify="center" h={`${size * 1.5}px`}>
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          w={`${size}px`}
          h={`${size}px`}
          bg={color}
          rounded="full"
          mx={1}
          __css={{
            animation: `${bounce} 1.4s infinite`,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </Flex>
  );
};
